import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FieldList from '../FieldList';
import Icon from '../../../misc/Icon';

import InputSettingsField from '../../settings/InputSettingsField';
import FieldListTypes from '../../../../constants/FieldListTypes';
import ThemeIcons from '../../../../theme/Icons';

const StyledSearchableFieldListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;

  ::-webkit-scrollbar {
    display:none; //hide scrollbar in chrome
  }
  scrollbar-width:none; // hide scrollbar in firefox
  -ms-overflow-style: none; // hide scroll bar in edge
`;

const StyledSearchInputWrapper = styled.div`
  padding: 16px;
`;

const StyledEmptyPlaceHolderWrapper = styled.div`
  width:100%;
  margin-top: 0px;
  text-align:center;
  font-weight; normal;
  font-size: 12px;
  color: ${(props) => props.theme.fontColorSecondary}
`;

const StyledFieldListContainer = styled.div`
  display: flex;
  flex: 1;
`;

const Fields = ({ fieldOptions, theme, height }) => {

  const [nextFields, setNextFields] = useState(fieldOptions);


  const handleSearchQueryChange = (value) => {

    /**
     * We are transforming the first character of the search query to uppercase
     * since our fieldTitles begin with an uppercase Character (ex: Image, Short Text etc)
     */
    const nextSearchQuery = value.replace(/\s/g, '').toLowerCase();

    //Logic to reset state incase search query is empty
    if (!nextSearchQuery || nextSearchQuery.length < 1) {

      setNextFields(fieldOptions);

      return null;

    }

    /**
    * Logic to merge fieldGroup.fields along with other fields
    * so that they are included in the list of fields to search
    * from when search Query is present.
    *
    * Sample Structure of field groups:
    *  {
          type: FieldListTypes.fieldGroup,
          title: 'Display Fields',
          open: true,
          fields: [
            {
              title: 'Image',
              type: FieldTypes.image,
              description: 'Logo or graphic'
            },
          ]
        },
    */
    const fieldGroupFields = [];

    fieldOptions.forEach((item) => {

      if (item.type === FieldListTypes.fieldGroup
        && item.fields
        && item.fields.length > 0) {

        item.fields.forEach((field) => fieldGroupFields.push(field));

      }

    });

    const nextFieldOptions = [...fieldOptions, ...fieldGroupFields];

    const matchingFields = nextFieldOptions.filter((item) => {

      const nextTitle = item.title.replace(/\s/g, '').toLowerCase();

      if (nextTitle === nextSearchQuery || nextTitle.includes(nextSearchQuery)) return item;

      return null;

    });

    setNextFields(matchingFields);

  };


  return (
    <StyledSearchableFieldListWrapper>
      <StyledSearchInputWrapper>
        <InputSettingsField
          onChangeText={handleSearchQueryChange}
          addonBefore={<Icon color={theme.fontColorPrimary} icon={ThemeIcons.misc.search} size="sm" />}
        />
      </StyledSearchInputWrapper>
      {nextFields && nextFields.length > 0 ? (
        <StyledFieldListContainer>
          <FieldList fields={nextFields} height={height} />
        </StyledFieldListContainer>
      ) : (<StyledEmptyPlaceHolderWrapper theme={theme}> No fields found</StyledEmptyPlaceHolderWrapper>)}
    </StyledSearchableFieldListWrapper>
  );
};

Fields.propTypes = {
  fieldOptions: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      fields: PropTypes.array,
      open: PropTypes.bool
    })
  ).isRequired,
  theme: PropTypes.object.isRequired
};

export default Fields;
